import { TranslateOptions } from 'vue-i18n';

import { currentLocale, i18n } from '@/plugins/i18n';
import { useCommunityStore } from '@/store/communityStore';
import { Locales } from '@/store/language.interface';

export function getLabel(
  key: string,
  languageEnabled: Locales[] | undefined = [],
  options: TranslateOptions<Locales> = {},
): string {
  options.locale = getLocale(languageEnabled);
  return i18n.global.t(key, key, options);
}

export function getLanguageName(
  languageEnabled: Locales[] | undefined = [],
  shouldBeLowerCase: boolean = false,
): string {
  const locale = getLocale(languageEnabled);
  const key = `languages.${locale}`;
  const name = i18n.global.t(key, key, { locale: currentLocale() });
  return shouldBeLowerCase ? name.toLowerCase() : name;
}

export function getLocale(languageEnabled: Locales[]): Locales {
  const locale = currentLocale();
  const community = useCommunityStore().community;
  if (languageEnabled.length === 0 && community.languageEnabled) {
    languageEnabled.push(...community.languageEnabled);
  }
  const defaultLanguage = community.defaultLanguage;
  // Prioritize the community's default language if available
  const defaultLocale = languageEnabled.includes(defaultLanguage) ? defaultLanguage : languageEnabled[0];
  // Select the locale based on the current user's locale if available or use the default locale
  return languageEnabled.includes(locale) ? locale : defaultLocale;
}

export function getTranslation(
  field: object,
  key: string,
  languageEnabled: Locales[] | undefined = [],
): string | undefined | null {
  if (!field?.[key]) return null;
  const locale = getLocale(languageEnabled);
  const fallbackLocales = languageEnabled.filter((x) => x != locale && field?.[key]?.[x]);
  return field?.[key]?.[locale] || field?.[key]?.[fallbackLocales?.[0]];
}

export function isOverflown(text: string, count: number): boolean {
  return text?.length > count;
}
